import OverviewActionTypes from '../actionTypes/overview.actionTypes'
import { ActionType } from './common.reducer'
import {
    OverviewWidgetResponse_FieldGroup,
    OverviewWidgetResponse_IndexComponent,
    PerformancePeriod
} from '../proto/generated/overview-widget'
import { CommunityScreenMetadata } from '../proto/generated/screener'

interface SecurityOverviewStateType {
    fieldGroups: OverviewWidgetResponse_FieldGroup[]
    indexComponents: OverviewWidgetResponse_IndexComponent[]
    performance: PerformancePeriod[]
    communityScreens: CommunityScreenMetadata[]
    overviewSecurityKey: string | null
    indexComponentTotalCount: number
    hasIndexContribution: boolean
}

const initialState: SecurityOverviewStateType = {
    fieldGroups: [],
    indexComponents: [],
    performance: [],
    communityScreens: [],
    overviewSecurityKey: null,
    indexComponentTotalCount: 0,
    hasIndexContribution: false,
}

export default function overviewReducer(state = initialState, action: ActionType) {
    const { type, payload } = action

    switch (type) {
        case OverviewActionTypes.SET_OVERVIEW_DATA:
            return {
                ...state,
                overviewSecurityKey: payload.securityKey,
                fieldGroups: payload.fieldGroups,
                indexComponents: payload.indexComponents,
                performance: payload.performance,
                communityScreens: payload.communityScreens,
                indexComponentTotalCount: payload.indexComponentTotalCount ?? 0,
                hasIndexContribution: payload.hasIndexContribution ?? false,
            }
        case OverviewActionTypes.CLEAR_OVERVIEW:
            return initialState
        default:
            return state
    }
}
